// extracted by mini-css-extract-plugin
export default {"link":"LoginType_link__s31H3"};